/* eslint-disable */

import { isNumber } from "util";

export const cpf = valor => (valor == null ? "" : valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4"));

export const cnpj = valor => (valor == null ? "" : valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5"));

export const moeda = valor =>
  valor != null
    ? "R$ " +
      parseFloat(valor, 0)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
    : null;

export const percentual = valor =>
  (valor && Number.isFinite(valor)) || valor === 0
    ? parseFloat(valor, 0)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.") + "%"
    : null;

export const quantidade = valor =>
  (valor && Number.isFinite(valor)) || valor === 0
    ? parseFloat(valor, 0)
        .toFixed(3)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
    : null;

export const telefone = phone => {
  if (phone && phone.length === 11) {
    return phone.replace(/\D/g, "").replace(/(\d{2})(\d)(\d{4})(\d{4})$/, "($1) $2 $3-$4");
  } else if (phone && phone.length === 10) {
    return phone.replace(/\D/g, "").replace(/(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }
  return phone;
};

export const remover = valor => {
  if (!valor || isNumber(valor)) {
    return valor;
  }

  valor = valor
    .toString()
    .replace("R$", "")
    .replace("%", "")
    .trim()
    .replace(".", "")
    .replace(",", ".");

  valor = parseFloat(valor, 0);
  return valor;
};

export const apenasNumeros = value => {
  if (!value) {
    return value;
  }
  return parseInt(value.toString().replace(/[\D]+/g, ""), 0);
};

export const converterBytesParaMB = fileSizeInBytes => {
  var i = -1;
  var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};



// WEBPACK FOOTER //
// ./src/utils/MascaraUtil.js